/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FieldProvenance
 */
export interface FieldProvenance {
    /**
     * 
     * @type {string}
     * @memberof FieldProvenance
     */
    source?: string;
    /**
     * 
     * @type {number}
     * @memberof FieldProvenance
     */
    priority?: number;
    /**
     * 
     * @type {Date}
     * @memberof FieldProvenance
     */
    updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof FieldProvenance
     */
    confidence?: number;
}

/**
 * Check if a given object implements the FieldProvenance interface.
 */
export function instanceOfFieldProvenance(value: object): value is FieldProvenance {
    return true;
}

export function FieldProvenanceFromJSON(json: any): FieldProvenance {
    return FieldProvenanceFromJSONTyped(json, false);
}

export function FieldProvenanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldProvenance {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'] == null ? undefined : json['source'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
    };
}

export function FieldProvenanceToJSON(json: any): FieldProvenance {
    return FieldProvenanceToJSONTyped(json, false);
}

export function FieldProvenanceToJSONTyped(value?: FieldProvenance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': value['source'],
        'priority': value['priority'],
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'confidence': value['confidence'],
    };
}

